import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxEditorModule, Editor, Toolbar } from 'ngx-editor';

@Component({
  selector: 'educare-rich-text-editor',
  standalone: true,
  imports: [CommonModule, FormsModule, NgxEditorModule],
  templateUrl: './rich-text-editor.component.html',
  styleUrl: './rich-text-editor.component.scss'
})
export class RichTextEditorComponent implements OnInit, OnDestroy {
  @Input() content: string = '';
  @Output() contentChange = new EventEmitter<string>();
  @Input() dir: 'ltr' | 'rtl' = 'ltr';

  editor!: Editor;

  toolbar: Toolbar = [
    ['undo', 'redo'],
    ['bold', 'italic', 'underline', 'strike'],
    ['text_color', 'background_color'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
    ['link'],
    ['horizontal_rule']
  ];

  ngOnInit(): void {
    this.editor = new Editor();
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  onContentChange(value: string) {
    this.contentChange.emit(value);
  }
}
